module.exports = __webpack_public_path__ + "img/6.481fae10.png";